export class RpcException extends Error {
  public err: Error;

  constructor(err: Error) {
    super();

    console.log({ err });

    this.message = err.message || "unknown rpc error";
    this.err = err;
  }
}
